<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #titleContent>
    <h3 class="modal__title">
      {{
        accountName
          ? ('ACCOUNTS_SETTINGS.DELETE_MODAL_MESSAGE' | translate: { name: accountName })
          : ('ACCOUNTS_SETTINGS.DELETE_MODAL_MESSAGE_NO_NAME' | translate)
      }}
    </h3>
  </ng-template>
</app-modal>
